import { StarterDashboardV2PageNotificationManagerContextProvider } from './context';
import { useStarterDashboardV2PageNotificationManager } from './hook';

export function StarterDashboardV2PageNotificationManagerProvider({
	children,
}: {
	children: React.ReactNode;
}): JSX.Element {
	const notificationManager = useStarterDashboardV2PageNotificationManager();

	return (
		<StarterDashboardV2PageNotificationManagerContextProvider value={notificationManager}>
			{children}
		</StarterDashboardV2PageNotificationManagerContextProvider>
	);
}
